module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cookiePanelText":"Gritify uses cookies to give you the best experience. By continuing to use the website, you agree to this.","OK":"OK","Läs mer":"Read more"},"sv":{"cookiePanelText":"Gritify använder cookies för att ge dig den bästa upplevelsen. Genom att fortsätta använda webbplatsen godkänner du detta.","OK":"OK","Läs mer":"Läs mer"}}')
  delete Component.options._Ctor
}
